<template>
    <v-dialog 
        :value="show"        
        fullscreen 
        hide-overlay
        @keydown.esc="close"
        transition="dialog-bottom-transition">
        <v-card>
            <v-toolbar dark color="primary">
                <v-btn 
                    icon 
                    dark 
                    :disabled="saving" 
                    @click="close">
                    <v-icon large>close</v-icon>
                </v-btn>
                <v-spacer></v-spacer>
                <v-toolbar-title>
                    <span v-if="originalItem">Edit Site Induction</span>
                    <span v-else>Add New Site Induction</span>
                </v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-layout row align-center justify-center fill-height v-if="loading">
                <v-flex shrink>
                    <v-progress-circular indeterminate></v-progress-circular>
                </v-flex>
            </v-layout>
            <v-form v-else ref="editForm" v-model="editValid">
                <v-layout class="dialog-content">
                    <v-flex xs12 md6 class="mt-2" offset-md3>
                        <v-layout row wrap>
                            <v-flex xs12>
                                <v-text-field
                                    class="pl-2 pr-2"
                                    label="Name"
                                    v-model="editedItem.Name">
                                </v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field
                                    class="pl-2 pr-2"
                                    label="Code"
                                    v-model="editedItem.Code">
                                </v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-checkbox
                                    v-model="editedItem.IsActive"
                                    label="Active"
                                >
                                </v-checkbox>
                            </v-flex>                                     
                        </v-layout>
                        <v-layout wrap class="dialog-action-buttons">
                            <v-flex xs12 sm6>
                                <v-btn 
                                    block 
                                    color="success" 
                                    :disabled="!editValid" 
                                    :loading="saving" 
                                    @click="save">
                                    <span>Save</span>
                                </v-btn>
                            </v-flex>
                            <v-flex xs12 sm6>
                                <v-btn 
                                    block 
                                    color="error" 
                                    :disabled="saving" 
                                    @click="close">
                                    <span>Cancel</span>
                                </v-btn>
                            </v-flex>
                        </v-layout>
                        <v-layout wrap>
                            <v-flex xs12>
                                <v-alert 
                                    :value="error" 
                                    outline 
                                    type="error">
                                    <span>{{ error }}</span>
                                </v-alert>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-form>
        </v-card>
    </v-dialog>
</template>

<script>
import plantConfigurationApi from "@/api/plantConfigurationApi";
import validationRules from "@/helpers/validationrules";
import BaseAPI from "@/api/baseApi";

export default {
    props: {
        plantID: {
            required: true,
            type: Number,
            default: null
        },
        originalItem: {
            required: false,
            type: Object,
            default: null
        },
        show: {
            required: true,
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            rules: validationRules.rules,
            loading: false,
            editedItem: {},            
            saving: false,
            error: null,
            editValid: false
        }
    },
    computed: {
    },    
    methods: {
        close(saved) {
            this.$refs.editForm.reset();
            this.$emit("close", saved);
        },
        async save() {
            try {
                this.saving = true;
                this.error = null;

                var result = await plantConfigurationApi.savePlantInduction(this.plantID, this.editedItem);

                if (!result.Success) {
                    this.error = result.ErrorMessages.join(', ');
                    return;
                }

                this.close(true);
            }
            catch (err) {
                this.error = await BaseAPI.parseHttpRequestError(err);
                throw err;
            }
            finally {
                this.saving = false;
            }
        }
    },
    async mounted() {
        if (this.originalItem) {
            this.editedItem = JSON.parse(JSON.stringify(this.originalItem));
        } else {
            this.editedItem.IsActive = true;
        }
    },
}
</script>
<style scoped>
</style>